import { SolidFavoriteUserHeartIcon, SolidUserIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';

export const getNumberOfCandidates = (candidates) => {
  const hasFavoriteCandidate = candidates?.some((candidate) => candidate.isFavorite);
  let candidateCount = candidates?.length;
  if (typeof candidateCount === 'number') {
    // Max is 5 candidates
    candidateCount = Math.min(candidateCount, 5);
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {hasFavoriteCandidate ? (
        <SolidFavoriteUserHeartIcon />
      ) : (
        <SolidUserIcon size={24} color={colors.secondary[500]} />
      )}
      <span
        style={{
          fontFamily: 'Nunito',
          fontWeight: 700,
          fontSize: 22,
          color: colors.secondary[500],
          marginTop: 6,
        }}
      >
        {candidateCount > 5 ? '5+' : candidateCount}
      </span>
    </div>
  );
};
